import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table-index-cell" }
const _hoisted_2 = { class: "table-index-cell__order" }
const _hoisted_3 = { class: "table-index-cell__id" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", {
  class: "mb-0",
  style: {"word-break":"break-word !important"}
}, "Cấp S/C", -1)
const _hoisted_5 = {
  class: "mb-0",
  style: {"word-break":"break-word !important"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", {
  class: "mb-0",
  style: {"word-break":"break-word !important"}
}, " Tên viết tắt ", -1)
const _hoisted_7 = {
  class: "mb-0",
  style: {"word-break":"break-word !important"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", {
  class: "mb-0",
  style: {"word-break":"break-word !important"}
}, " T/tin tài khoản ", -1)
const _hoisted_9 = {
  class: "mb-0",
  style: {"word-break":"break-word !important"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", {
  class: "mb-0",
  style: {"word-break":"break-word !important"}
}, "Mô tả", -1)
const _hoisted_11 = {
  class: "mb-0",
  style: {"word-break":"break-word !important"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", {
  class: "mb-0",
  style: {"word-break":"break-word !important"}
}, "ĐMCĐ", -1)
const _hoisted_13 = {
  class: "mb-0 text-end",
  style: {"word-break":"break-word !important"}
}

import { PropType, ref } from "vue";
import {
  ICapSuaChuaResponseBase,
  ITaiKhoanKeToanResponse,
} from "@/core/interfaces/ApiResponses";
import { useLoading } from "@/core/hooks/use-loading";
import { usePagination } from "@/core/hooks/use-pagination";
import { useRouter } from "vue-router";
import Setting from "@/components/shared/setting/Setting.vue";
import type { SettingAction } from "@/components/shared/setting/Setting.vue";
import CapSuaChuaDetailModal from "@/components/cap-sua-chua/CapSuaChuaDetailModal.vue";
import IconEye from "@/icons/IconEye.vue";
import IconPencil from "@/icons/IconPencil.vue";
import IconTrash from "@/icons/IconTrash.vue";
import { useStore } from "vuex";
import { withListPage } from "@/core/helpers/list-page-context";
import { CapSuaChuaService } from "@/core/services/CapSuaChuaService.service";
import { swalErrNotification, swalNotification } from "@/core/helpers/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'CapSuaChuaTable',
  props: {
  curPage: {
    type: Number,
    default: 0,
  },
  items: {
    type: Array as PropType<ICapSuaChuaResponseBase[]>,
    required: true,
  },
  perPage: {
    type: Number,
    default: 0,
  },
  showDmcdColumn: {
    type: Boolean,
    default: false,
  },
  /** When set (update page), highlight the row for the item being edited */
  selectedId: {
    type: Number,
    default: 0,
  },
},
  setup(__props) {

const props = __props;

const { push, replace } = useRouter();

const { startLoading, endLoading } = useLoading();

const store = useStore();

const { indexCal } = usePagination();

const selectedCapSuaChuaId = ref<number | undefined>(undefined);

const rowClassName = ({
  row,
}: {
  row: ICapSuaChuaResponseBase;
}): string => {
  if (props.selectedId > 0 && row.id === props.selectedId) {
    return "current-row";
  }

  return "";
};

const onDeleteButtonClick = (row: ICapSuaChuaResponseBase) => {
  store.commit("ConfirmationDialogModule/setDialog", {
    message: `Bạn có chắc chắn muốn xoá cấp sửa chữa ${row.ten_cap_sc}?`,
    onConfirm: async () => {
      store.commit("ConfirmationDialogModule/closeDialog");
      await startLoading();

      try {
        await CapSuaChuaService.delete(row.id);
        await endLoading();
        await swalNotification("Xoá cấp sửa chữa thành công");

        await replace({
          name: "danh-sach-cap-sua-chua",
        });
      } catch (e) {
        await endLoading();
        await swalErrNotification(e, "Không thể xoá cấp sửa chữa này");
      }
    },
  });
};

const getSettingActions = (row: ICapSuaChuaResponseBase): SettingAction[] => [
  {
    icon: IconEye,
    label: "Chi tiết",
    tooltip: "Chi tiết",
    onClick: () => {
      selectedCapSuaChuaId.value = row.id;
    },
  },
  {
    icon: IconPencil,
    label: "Chỉnh sửa",
    tooltip: "Chỉnh sửa",
    any: ["master:capsc:sua"],
    onClick: () =>
      push(
        withListPage(
          {
            name: "chinh-sua-cap-sua-chua",
            params: { id: String(row.id) },
          },
          props.curPage
        )
      ),
  },
  {
    icon: IconTrash,
    label: "Xoá",
    any: ["master:capsc:xoa"],
    onClick: () => onDeleteButtonClick(row),
  },
];

const taiKhoanDisplay = ({ matk, mact, tentk }: ITaiKhoanKeToanResponse) =>
  `${matk} / ${mact || '-'} / ${tentk}`;

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CapSuaChuaDetailModal, {
      id: selectedCapSuaChuaId.value,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (selectedCapSuaChuaId.value = undefined))
    }, null, 8, ["id"]),
    _createVNode(_component_el_table, {
      border: true,
      "empty-text": "Chưa có cấp sửa chữa",
      data: __props.items,
      "row-class-name": rowClassName
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "STT",
          width: "70"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(indexCal)(scope.$index, __props.curPage, __props.perPage)), 1),
              _createElementVNode("span", _hoisted_3, "(" + _toDisplayString(scope.row.id) + ")", 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { width: "300" }, {
          header: _withCtx(() => [
            _hoisted_4
          ]),
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_5, _toDisplayString(scope.row.ten_cap_sc), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { width: "120" }, {
          header: _withCtx(() => [
            _hoisted_6
          ]),
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_7, _toDisplayString(scope.row.ten_viet_tat || "-"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { width: "350" }, {
          header: _withCtx(() => [
            _hoisted_8
          ]),
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_9, _toDisplayString(taiKhoanDisplay(scope.row.tk_ketoan)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, null, {
          header: _withCtx(() => [
            _hoisted_10
          ]),
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_11, _toDisplayString(scope.row.mo_ta ?? "-"), 1)
          ]),
          _: 1
        }),
        (__props.showDmcdColumn)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              width: "150"
            }, {
              header: _withCtx(() => [
                _hoisted_12
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("p", _hoisted_13, _toDisplayString(scope.row.dinh_muc_co_dinh_count || "-"), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          width: "50",
          fixed: "right"
        }, {
          default: _withCtx((scope) => [
            _createVNode(Setting, {
              actions: getSettingActions(scope.row)
            }, null, 8, ["actions"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])
  ], 64))
}
}

})